import { render, staticRenderFns } from "./ResultTableMainChannel.vue?vue&type=template&id=2db6505a&scoped=true&"
import script from "./ResultTableMainChannel.vue?vue&type=script&lang=js&"
export * from "./ResultTableMainChannel.vue?vue&type=script&lang=js&"
import style0 from "./ResultTableMainChannel.vue?vue&type=style&index=0&id=2db6505a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db6505a",
  null
  
)

export default component.exports